import { useTranslation } from "react-i18next";
import useCredentials from "../../common/hooks/credentialsHook"
import { useSuperMember } from "../../reducers/member/memberSuperSlice";
import { canViewMemberRosters, realizeMgrMemberLastRoster, useMgrMemberLastRoster } from "../../reducers/roster/rosterMgrSlice";
import DateTimeInput from "../../common/components/DateTimeInput";
import { useMemo } from "react";
import useClientConfig from "../../common/hooks/clientConfigHook";
import { cdate } from "../../common/utils/CDate";

export const toString = async ({ value, tz, defaultValue, t, ...props }) => {
    if (!value) {
        return defaultValue;
    }
    if (!canViewMemberRosters(props.credentials, value)) {
        return t('notAutorized');
    }
    const lastRoster = await realizeMgrMemberLastRoster(props, value, props.clientConfig);
    if (lastRoster) {
        return cdate(lastRoster.display_actual_start, tz).dateTimeFormat();
    }
    return t('unknown')
}

const MemberLastRosterImpl = ({ memberid, tz }) => {
    const { t } = useTranslation();
    const clientConfig = useClientConfig();
    const roster = useMgrMemberLastRoster(memberid, clientConfig);
    return roster ? <DateTimeInput readonly value={roster?.display_actual_start} tz={tz} hideLabel></DateTimeInput> : t('unknown')
}

const MemberLastRoster = ({ memberid, tz }) => {
    const { t } = useTranslation();
    const credentials = useCredentials();
    const member = useSuperMember(memberid);
    const canViewRosters = useMemo(() => member && canViewMemberRosters(credentials, member), [credentials, member]);

    if (memberid && canViewRosters) {
        return <MemberLastRosterImpl memberid={memberid}></MemberLastRosterImpl>
    } else {
        return <>{t('notAuthorized')}</>
    }
}

export default MemberLastRoster;